<template>
  <div class="text-left">
    <h5>
      <strong>{{ $t("name") }}:</strong> {{ title }}
      <span class="ml-5" v-if="supervisor"
        ><strong> Supervisor:</strong> {{ supervisor.username }}</span
      >
    </h5>
    <v-divider />
    <v-card>
      <v-form class="pa-6" ref="form">
        <ReviewPublication
          :mod-op_id="modOp_id"
          :publication="publication"
          teseo_link
        />
        <v-row>
          <v-col cols="12">
            <h3 class="mt-15 mb-0">{{ $t("title.thesisData") }}</h3>
          </v-col>
        </v-row>
        <h5>
          {{ $t("form.thesis.doctoral_program") }}
        </h5>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-text-field
              v-model="publication.thesis.doctoral_program"
              :label="$t('form.thesis.doctoral_program')"
              required
              outlined
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <h5>
          {{ $t("label.dates") }}
        </h5>
        <v-row>
          <v-col cols="12" sm="6" class="py-0">
            <v-text-field
              outlined
              v-model="publication.thesis.start_date"
              :label="$t('form.thesis.start_date')"
              prepend-inner-icon="event"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="py-0">
            <v-text-field
              outlined
              v-model="publication.thesis.deposit_date"
              :label="$t('form.thesis.deposit_date')"
              prepend-inner-icon="event"
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <h5>
          {{ $t("form.thesis.thesisLecture") }}
        </h5>
        <v-row>
          <v-col cols="12" sm="12" md="6" class="py-0">
            <v-text-field
              v-model="publication.thesis.read_center"
              :label="$t('form.thesis.read_center')"
              required
              outlined
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="py-0">
            <v-text-field
              outlined
              v-model="publication.thesis.lecture_date"
              :label="$t('form.thesis.lecture_date')"
              prepend-inner-icon="event"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="3" class="py-0">
            <v-text-field
              v-model="publication.thesis.grade"
              :label="$t('form.thesis.grade')"
              required
              outlined
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0">
            <h5>
              {{ $t("form.thesis.international_phd") }}
            </h5>
            <v-checkbox
              class="big"
              v-model="publication.thesis.international_phd"
              :label="$t('form.thesis.internationalPhdDetail')"
              readonly
            />
          </v-col>
        </v-row>
        <h5>{{ $t("form.thesis.directors") }}</h5>
        <SelectPeopleComboBox
          :disabled-form="true"
          :items-selected="publication.thesis.directors"
        />
        <h5>{{ $t("form.thesis.tutor") }}</h5>
        <v-row>
          <v-col cols="12" class="py-0">
            <v-text-field
                v-if="tutorSelected !== undefined && tutorSelected !== null"
              :value="tutorSelected.name"
              return-object
              outlined
              readonly
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </v-card>
    <DirectorActions
      v-if="isAuthorize"
      :object_type="object_type"
      class="mt-6"
    />
    <SupervisorActions
      v-else
      :item="publication"
      :object_type="object_type"
      :form_name="form_name"
      :state="state"
      :supervisor="supervisor !== null ? supervisor.username : ''"
      @change-state-supervisor="onStateSupervisorChange"
      class="mt-6"
    />
  </div>
</template>

<script>
import axios from "axios";
import changeState from "../../../mixins/changeState";
import DirectorActions from "../../action_buttons/DirectorActions";
import SupervisorActions from "../../action_buttons/SupervisorActions";
import ReviewPublication from "./ReviewPublication";
import SelectPeopleComboBox from "../../reusables/SelectPeopleComboBox";
import publication_model from "../../../mixins/model_utils/publication_model";

export default {
  mixins: [changeState, publication_model],
  components: {
    SelectPeopleComboBox,
    ReviewPublication,
    SupervisorActions,
    DirectorActions
  },

  data: () => ({
    form_name: "newThesisForm",
    state: "",
    title: "",
    supervisor: "",
    object_id: null,
    object_type: "publication",
    tutorSelected: null,
    modOp_id: null,
    publication: {
      title: "",
      abstract: "",
      keywords: "",
      doi: "",
      isbn: "",
      links: "",
      authors: [],
      authors_text: "",
      thesis: ""
    }
  }),

  created() {
    this.getPublication();
  },

  computed: {
    isAuthorize() {
      return this.$route.meta.authorize !== undefined;
    }
  },

  watch: {
    namePersons(){
      this.loadTutorSelected(this.publication.thesis.tutor)
    }
  },

  methods: {
    loadTutorSelected(item) {
      if (typeof item == "number") {
        this.tutorSelected = this.namePersons.filter(
          tutor => tutor.id === item
        )[0];
      } else {
        this.tutorSelected = item;
      }
    },
    getPublication() {
      let path =
        this.$store.state.endpoint +
        "/moderatedOperations/review/publication/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.modOp_id = response.data.id;
          this.publication = response.data.data.user.publication;
          this.state = response.data.state;
          this.reject_comment = response.data.reject_comment;
          this.object_id = response.data.object_id;
          this.supervisor = response.data.supervisor;
          this.title = response.data.title;
          this.loadTutorSelected(this.publication.thesis.tutor);
        })
        .catch(error => {
          console.log(error);
        });
    },
    onStateSupervisorChange(state, supervisor) {
      this.state = state;
      this.supervisor = supervisor;
    }
  }
};
</script>
